export default __webpack_public_path__ + "static/media/ventes.73bd7e50.gif";